import { render } from "./Twitter.vue?vue&type=template&id=7b56bf8a"
import script from "./Twitter.vue?vue&type=script&lang=js"
export * from "./Twitter.vue?vue&type=script&lang=js"
script.render = render

export default script